import { SummaryStatsCard } from '@exam-center/components';
import {
  ExamEventExamineeStatus,
  ExamineeRegistrationStatus,
  ExamResult,
} from '@exam-center/graphql';
import { Flex } from '@shared/components';
import { useMemo } from 'react';

import { useExamEventScoreReport } from '../../providers/exam-event-score-report-provider/use-exam-event-score-report';

export default function ExamEventScoreReportSummarySection() {
  const { scoreReports, isLoading, hasFilters } = useExamEventScoreReport();

  const summary = useMemo(() => {
    // attendedCount is examinee who is registered
    const attendedCount = scoreReports.filter(
      (scoreReport) => scoreReport.registrationStatus === ExamineeRegistrationStatus.Registered,
    ).length;

    const absentCount = scoreReports.filter(
      (scoreReport) => scoreReport.status === ExamEventExamineeStatus.Absent,
    ).length;

    const canceledCount = scoreReports.filter(
      (scoreReport) => scoreReport.status === ExamEventExamineeStatus.Canceled,
    ).length;

    const completedCount = scoreReports.filter(
      (scoreReport) =>
        scoreReport.status === ExamEventExamineeStatus.PendingResults ||
        scoreReport.status === ExamEventExamineeStatus.Completed ||
        scoreReport.status === ExamEventExamineeStatus.Finished,
    ).length;

    const passedCount = scoreReports.filter(
      (scoreReport) => scoreReport.result === ExamResult.Passed,
    ).length;

    const failedCount = scoreReports.filter(
      (scoreReport) => scoreReport.result === ExamResult.Failed,
    ).length;

    return {
      attendedCount,
      absentCount,
      canceledCount,
      completedCount,
      passedCount,
      failedCount,
    };
  }, [scoreReports]);

  return (
    <Flex
      sx={(theme) => ({
        gap: theme.spacing(4),
      })}
    >
      <SummaryStatsCard
        title='ผู้สมัครสอบ'
        displayValue={hasFilters ? `${scoreReports.length} คน` : '—'}
        color='warning'
        loading={isLoading}
        sx={(theme) => ({
          '.MuiTypography-root': {
            color: theme.palette.text.secondary,
          },
          '.MuiTypography-h3': {
            color: theme.palette.text.primary,
          },
        })}
      />
      <SummaryStatsCard
        title='ลงทะเบียน'
        displayValue={hasFilters ? `${summary.attendedCount} คน` : '—'}
        loading={isLoading}
      />
      <SummaryStatsCard
        title='ขาดสอบ'
        displayValue={hasFilters ? `${summary.absentCount} คน` : '—'}
        loading={isLoading}
      />
      <SummaryStatsCard
        title='ยกเลิก'
        displayValue={hasFilters ? `${summary.canceledCount} คน` : '—'}
        loading={isLoading}
      />
      <SummaryStatsCard
        title='สอบเสร็จ'
        displayValue={hasFilters ? `${summary.completedCount} คน` : '—'}
        loading={isLoading}
      />
      <SummaryStatsCard
        title='สอบผ่าน'
        displayValue={hasFilters ? `${summary.passedCount} คน` : '—'}
        color='success'
        loading={isLoading}
      />
      <SummaryStatsCard
        title='สอบไม่ผ่าน'
        displayValue={hasFilters ? `${summary.failedCount} คน` : '—'}
        color='error'
        loading={isLoading}
      />
    </Flex>
  );
}
